/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Never_TrainedInputs */

const en_us2_coaching_never_trained = /** @type {(inputs: Coaching_Never_TrainedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Has not trained yet`)
};

const pt_br2_coaching_never_trained = /** @type {(inputs: Coaching_Never_TrainedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda não treinou`)
};

const pt_pt2_coaching_never_trained = /** @type {(inputs: Coaching_Never_TrainedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda não treinou`)
};

/** @type {(inputs: Coaching_Never_TrainedInputs) => LocalizedString} */
const es_419_coaching_never_trained = en_us2_coaching_never_trained;

/** @type {(inputs: Coaching_Never_TrainedInputs) => LocalizedString} */
const fr_fr2_coaching_never_trained = en_us2_coaching_never_trained;

/** @type {(inputs: Coaching_Never_TrainedInputs) => LocalizedString} */
const de_de2_coaching_never_trained = en_us2_coaching_never_trained;

/** @type {(inputs: Coaching_Never_TrainedInputs) => LocalizedString} */
const it_it2_coaching_never_trained = en_us2_coaching_never_trained;

/**
* | output |
* | --- |
* | "Has not trained yet" |
*
* @param {Coaching_Never_TrainedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_never_trained = /** @type {((inputs?: Coaching_Never_TrainedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Never_TrainedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_never_trained(inputs)
	if (locale === "es-419") return es_419_coaching_never_trained(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_never_trained(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_never_trained(inputs)
	if (locale === "de-DE") return de_de2_coaching_never_trained(inputs)
	if (locale === "it-IT") return it_it2_coaching_never_trained(inputs)
	return en_us2_coaching_never_trained(inputs)
});
export { coaching_never_trained as "coaching.never_trained" }